import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-header-title" }
const _hoisted_4 = { class: "card-content" }
const _hoisted_5 = { class: "tags" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Strength:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Weakness:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.ghostCard.name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ghostCard.evidence, (evidence) => {
          return (_openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["tag is-light", { [evidence.color]: true, 'has-line-through': evidence.found }]),
            key: evidence
          }, _toDisplayString(evidence.name), 3))
        }), 128))
      ]),
      _createElementVNode("p", null, [
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.ghostCard.strength), 1)
      ]),
      _createElementVNode("p", null, [
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_ctx.ghostCard.weakness), 1)
      ])
    ])
  ]))
}